import { Outlet } from 'react-router-dom';
import RedirectHandler from './RedirectHandler';

function RouteManager() {
  return (
    <>
      <RedirectHandler />
      <Outlet />
    </>
  );
}

export default RouteManager;
